import { useContext } from 'react';
import EventContext from '../context/EventContext';

export const useEvent = () => {
    const context = useContext(EventContext);
    if (context === undefined) {
        throw new Error("useEvent doit être utilisé à l'intérieur d'un EventProvider");
    }
    return context;
};
